import React, { useState, useEffect } from 'react';
import { getAuth } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import { VscArrowCircleRight, VscArrowCircleLeft } from "react-icons/vsc";
import './officerosania.css';
import { storage, db, auth } from '../Firebase/Firebase.js';
import { getDownloadURL, ref } from 'firebase/storage';
import { getFirestore, collection, doc, getDoc, addDoc, updateDoc, query, where, getDocs, setDoc } from "firebase/firestore";
import { useParams } from 'react-router-dom';
import DiseñoIzquierda from '../images/imgLateralIzquierdaEvento.png';
import reseñastemp from '../images/reseñastemp.png';
import ReactSlider from 'react-slider';
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { FaUsers, FaProjectDiagram, FaCalendar, FaStar, FaMapMarkerAlt, FaDollarSign, FaSearch } from 'react-icons/fa';
import Navbar from '../Components/NavBarV2';
import Footer from '../Components/footer';
import Modal from 'react-modal';
import { gapi } from 'gapi-script';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingScreen from '../Components/loading.js';
//import { getFunctions, httpsCallable } from 'firebase/functions';

Modal.setAppElement('#root');

const Officerosania = () => {
    const { IdEspacio } = useParams();
    const [images, setImages] = useState([]);
    const [currentImage, setCurrentImage] = useState(0);
    const [selectedRange, setSelectedRange] = useState([new Date(), new Date()]);

    const [timeRange, setTimeRange] = useState([0, 24]); // [horaInicial, horaFinal]
    const [cost, setCost] = useState(0);
    const costPerHour = 4;
    const [iconUrl, setIconUrl] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [EspacioData, setEspacioData] = useState(0);
    const [userId, setUserId] = useState(null);
    const [coins, setCoins] = useState(0);
    const [cedula, setCedula] = useState(0);
    const [ruc, setRuc] = useState(0);
    const [espacioId, setEspacioId] = useState(''); // Id del espacio general
    const [cedulaRucModalIsOpen, setCedulaRucModalIsOpen] = useState(false); // Nuevo estado para el modal de cédula o RUC
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [modalMessageClass, setModalMessageClass] = useState(''); // Clase CSS para el mensaje
    const [hasCedulaOrRuc, setHasCedulaOrRuc] = useState(false); // Estado para saber si el usuario tiene cédula o RUC
    const [cedulaRuc, setCedulaRuc] = useState(""); // Para el input en el modal
    const [errorMessage, setErrorMessage] = useState(""); // Mensaje de error
    const [errorModalIsOpen, setErrorModalIsOpen] = useState(false); // Modal de error
    const [successModalIsOpen, setSuccessModalIsOpen] = useState(false); // Modal de éxito
    const [reseñas, setReseñas] = useState([]);
    const [promedioCalificacion, setPromedioCalificacion] = useState(0);
    const [currentReseñaIndex, setCurrentReseñaIndex] = useState(0);
    const [horariosOcupados, setHorariosOcupados] = useState([]);
    const [isSelectingStartDate, setIsSelectingStartDate] = useState(true);
    const [loading, setLoading] = useState(true);
    const [view, setView] = useState("Fechas");
    //Datos para crear el evento en calendario
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFinal, setFechaFinal] = useState(new Date());
    const [horaInicio, setHoraInicio] = useState(new Date());
    const [horaFinal, setHoraFinal] = useState(new Date());
    const [userName, setUserName] = useState('');
    const [calendarId, setCalendarId] = useState('');
    const navigate = useNavigate();
    const [currentDate, setCurrentDate] = useState(new Date());
    const [activeStartDate1, setActiveStartDate1] = useState(new Date());
    const [activeStartDate2, setActiveStartDate2] = useState(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1));

    useEffect(() => {
        //recupera las imagenes del storage de Firebase
        const fetchImages = async () => {
            const urls = [];
            for (let i = 1; i <= 4; i++) {
                const imageRef = ref(storage, `FotosEspacio/${IdEspacio}/${IdEspacio}${i}.png`);
                try {
                    const url = await getDownloadURL(imageRef);
                    urls.push(url); // Si se obtiene la URL, se agrega al array

                } catch (error) {
                    // Si ocurre un error (por ejemplo, la imagen no existe), continúa con el siguiente formato
                    //console.error(`Error fetching image ${IdEspacio}${i}.png:`, error);
                }
            }
            setImages(urls);
        };

        const fetchIcon = async () => {
            const iconRef = ref(storage, `FotosEspacio/${IdEspacio}/${IdEspacio}logo.png`);
            try {
                const url = await getDownloadURL(iconRef);
                setIconUrl(url); // Si se obtiene la URL, se establece
                return; // Salimos de la función si se encuentra el logo
            } catch (error) {
                // Continúa con el siguiente formato si ocurre un error
                //console.error(`Error fetching icon ${IdEspacio}logo.png:`, error);
            }
            //console.warn('No se encontró el logo en ninguno de los formatos especificados.');
            setIconUrl(null); // O establecer a null o un valor predeterminado
        };

        const fetchEspacioData = async () => {
            const auth = getAuth();
            const currentUser = auth.currentUser;
            if (currentUser) {
                const docRef = doc(db, "usuarios", currentUser.uid); // Reemplaza con tu colección y ID
                const docSnapU = await getDoc(docRef);

                if (docSnapU.exists()) {
                    setUserName(docSnapU.data().name + " " + docSnapU.data().lastName);
                } else {
                    //console.log("No existe el documento");
                }
            }
            // Consulta a la tabla "espacios"
            const espacioDoc = doc(db, "espacios", IdEspacio);
            const docSnap = await getDoc(espacioDoc);
            if (docSnap.exists()) {
                setCalendarId(docSnap.data().calendarID);
            }
            if (docSnap.exists()) {
                const espacioData = docSnap.data();
                setEspacioData({
                    accesorios: espacioData.Accesorios,
                    capacidadMax: espacioData.CapacidadMax,
                    capacidadMin: espacioData.CapacidadMin,
                    color: espacioData.Color,
                    descripcion: espacioData.DescripcionEspacio,
                    nombre: espacioData.NombreEspacio,
                    IdtipoEspacio: espacioData.TipoEspacio,
                    lugar: espacioData.IdLugar,  // Obtenemos el IdLugar
                });
                // Después de obtener los datos de "espacios", hacemos una consulta a "lugar"
                const lugarDoc = doc(db, "lugar", espacioData.IdLugar);  // Usamos el IdLugar para obtener el NombreLugar
                const lugarSnap = await getDoc(lugarDoc);

                if (lugarSnap.exists()) {
                    const lugarData = lugarSnap.data();
                    setEspacioData((prevData) => ({
                        ...prevData,
                        nombreLugar: lugarData.NombreLugar,  // Actualizamos el estado con NombreLugar
                    }));
                } else {
                    // console.log("No se encontró el lugar con el ID proporcionado");
                }
                const espacioDoc = doc(db, "tipoespacio", espacioData.TipoEspacio);
                const tipoSnap = await getDoc(espacioDoc);
                if (tipoSnap.exists()) {
                    const tipoData = tipoSnap.data();
                    setEspacioData((prevData) => ({
                        ...prevData,
                        descripcionespacio: tipoData.DescripcionEspacio,  // Actualizamos el estado con Descripcion
                        tipoespacio: tipoData.TipoEspacio
                    }));

                    setLoading(false);


                } else {
                    console.log("No se encontró el lugar con el ID proporcionado");
                }
            } else {
                console.log("No se encontró el espacio con el ID proporcionado");
            }
        };

        fetchImages();
        fetchIcon();
        fetchEspacioData();  // Trae los datos del espacio y del lugar
    }, [IdEspacio]);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    const getThumbnailImages = () => {
        let thumbnails = [];
        for (let i = 1; i < images.length; i++) {
            thumbnails.push(images[(currentIndex + i) % images.length]);
        }
        return thumbnails;
    };
    useEffect(() => {
        const hours = (timeRange[1] - timeRange[0]) / 2; // Divides entre 2 porque cada valor de timeRange equivale a 30 minutos
        const days = (selectedRange[1] - selectedRange[0]) / (1000 * 60 * 60 * 24); // Calcula días
        let totalCost = hours * costPerHour * (days === 0 ? 1 : days); // Multiplica el costo por los días, al menos 1 día
        setCost(totalCost.toFixed(0)); // Redondea a un número entero
    }, [timeRange, selectedRange]);


    const handleTimeChange = (val) => {
        setTimeRange(val);
        setHoraInicio(formatTime(val[0]));
        setHoraFinal(formatTime(val[1]));
    };

    const handleDateChange = (date) => {
        if (!fechaInicio || (fechaInicio && fechaFinal)) {
            // Si no hay fechaInicio o ambas fechas están seleccionadas, la nueva fecha es la de inicio
            setSelectedRange([date, selectedRange[1]]);
            setFechaInicio(date);
            setFechaFinal(null);
        } else if (!fechaFinal) {
            // Si solo hay fechaInicio, la nueva fecha es la de final (si es mayor)
            if (date >= fechaInicio) {
                setFechaFinal(date);
                setSelectedRange([selectedRange[0], date]);
            } else {
                // Si la fecha es menor a la fechaInicio, la intercambiamos
                setFechaFinal(fechaInicio);
                setSelectedRange([selectedRange[0], fechaInicio]);

                setFechaInicio(date);
                setSelectedRange([date, selectedRange[1]]);

            }
        } else {
            // Si ambas fechas ya están seleccionadas, modificar según la lógica:
            if (date < fechaInicio) {
                // Nueva fecha de inicio
                setFechaInicio(date);
                setSelectedRange([date, selectedRange[1]]);

            } else if (date > fechaFinal) {
                // Nueva fecha de final
                setFechaFinal(date);
                setSelectedRange([selectedRange[0], date]);

            }
        }
        console.log(fechaInicio, fechaFinal);
    };
    const formattedStartDate = selectedRange[0]?.toLocaleDateString("es-ES") || 'No seleccionada';
    const formattedEndDate = selectedRange[1]?.toLocaleDateString("es-ES") || 'No seleccionada';

    const formatTime = (value) => {
        const hours = Math.floor(value / 2);
        const minutes = (value % 2) * 30;
        return `${hours < 10 ? '0' : ''}${hours}:${minutes === 0 ? '00' : '30'}`;
    };


    const openModal = (message, title) => {
        setModalTitle(title === 'positive' ? '¡Genial!' : '¡Lo sentimos !');
        setModalMessage(message);
        setModalIsOpen(true);
    };


    const closeModal = () => {
        setModalIsOpen(false);
    };

    const handleSubmit = async () => {
        const validarIdentificacionEcuador = (identificacion) => {
            // Verificar longitud
            if (identificacion.length !== 10 && identificacion.length !== 13) {
                return "La identificación debe tener 10 o 13 dígitos.";
            }

            // Validar cédula (primeros 10 dígitos)
            const cedula = identificacion.substring(0, 10);

            // Validar región
            const digitoRegion = parseInt(cedula.substring(0, 2), 10);
            if (digitoRegion < 1 || digitoRegion > 24) {
                return "La cédula no pertenece a ninguna región válida.";
            }

            // Validar último dígito de la cédula
            const ultimoDigito = parseInt(cedula.substring(9, 10), 10);

            // Sumar pares
            const pares =
                parseInt(cedula.substring(1, 2), 10) +
                parseInt(cedula.substring(3, 4), 10) +
                parseInt(cedula.substring(5, 6), 10) +
                parseInt(cedula.substring(7, 8), 10);

            // Procesar impares
            const calcularImpar = (digito) => {
                const resultado = digito * 2;
                return resultado > 9 ? resultado - 9 : resultado;
            };

            const impares =
                calcularImpar(parseInt(cedula.substring(0, 1), 10)) +
                calcularImpar(parseInt(cedula.substring(2, 3), 10)) +
                calcularImpar(parseInt(cedula.substring(4, 5), 10)) +
                calcularImpar(parseInt(cedula.substring(6, 7), 10)) +
                calcularImpar(parseInt(cedula.substring(8, 9), 10));

            // Sumar total
            const sumaTotal = pares + impares;

            // Extraer primer dígito de la suma
            const primerDigitoSuma = parseInt(String(sumaTotal).substring(0, 1), 10);

            // Decena inmediata
            const decenaInmediata = (primerDigitoSuma + 1) * 10;

            // Calcular dígito validador
            let digitoValidador = decenaInmediata - sumaTotal;
            if (digitoValidador === 10) digitoValidador = 0;

            // Verificar dígito validador
            if (digitoValidador !== ultimoDigito) {
                return "La cédula no es válida.";
            }

            // Si tiene 13 dígitos, validar RUC
            if (identificacion.length === 13) {
                const ruc = identificacion.substring(10, 13);
                if (ruc !== "001") {
                    return "El RUC debe terminar en 001.";
                }
            }

            return null; // La identificación es válida
        };

        const errorMessage = validarIdentificacionEcuador(cedulaRuc);
        if (errorMessage) {
            setErrorMessage(errorMessage);
            setErrorModalIsOpen(true); // Mostrar el modal de error
        } else {
            if (cedulaRuc.length === 10) { // Validación para cédula
                await saveCedulaOrRuc(cedulaRuc, 'cedula');
                setModalIsOpen(false);
            } else if (cedulaRuc.length === 13) { // Validación para RUC
                await saveCedulaOrRuc(cedulaRuc, 'ruc');
                setModalIsOpen(false);
            }
        }
    };

    // Función para guardar la cédula o RUC en la base de datos
    const saveCedulaOrRuc = async (cedulaRuc, type) => {
        try {
            const userRef = doc(db, 'usuarios', userId);
            await updateDoc(userRef, {
                [type]: cedulaRuc, // Usar 'cedula' o 'ruc' según corresponda
            });

            // Actualizar el estado de cédula o RUC en el componente
            if (type === 'cedula') {
                setCedula(cedulaRuc);
                setCedulaRucModalIsOpen(false);
            } else {
                setRuc(cedulaRuc);
                setCedulaRucModalIsOpen(false);
            }

            // Mostrar modal de éxito
            setSuccessModalIsOpen(true); // Abrir el modal de éxito
        } catch (error) {
            console.error("Error guardando la cédula o RUC: ", error);
        }
    };


    // Función para manejar el cambio en el input
    const handleChange = (e) => {
        const value = e.target.value;
        // Permitir solo números
        if (/^\d*$/.test(value)) {
            setCedulaRuc(value);
        }
    };
    const [valorSeleccionado, setValorSeleccionado] = useState(0); // Estado para el valor actual del slider}

    // Función para convertir la hora en formato HH:MM a un índice de 0 a 48 (media hora cada unidad)
    const parseToIndex = (time) => {
        const [hour, minutes] = time.split(":").map(Number);
        const index = hour * 2 + (minutes === 30 ? 1 : 0); // Multiplica por 2 para cada bloque de media hora
        // console.log(`Convirtiendo hora ${time} a índice: ${index}`);
        return index;
    };

    // Cargar los horarios ocupados desde Firebase
    useEffect(() => {
        const fetchHorariosOcupados = async () => {
            try {
                const querySnapshot = await getDocs(
                    query(collection(db, "reservas"), where("IdEspacio", "==", IdEspacio))
                );

                const ocupados = [];

                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    const startIndex = parseToIndex(data.horaInicio); // Convierte horaInicio a índice
                    const endIndex = parseToIndex(data.horaFinal);  // Convierte horaFinal a índice

                    // console.log(`Reserva de ${data.horaInicio} a ${data.horaFinal} -> Índices: ${startIndex} a ${endIndex}`);

                    // Añadir todos los índices entre startIndex y endIndex a la lista de ocupados
                    for (let i = startIndex; i < endIndex; i++) {
                        ocupados.push(i); // Guarda los índices ocupados
                    }
                });

                setHorariosOcupados(ocupados); // Actualiza el estado
                //console.log("Horarios ocupados:", ocupados);
            } catch (error) {
                //console.error("Error fetching horarios ocupados: ", error);
            }
        };

        fetchHorariosOcupados();
    }, [IdEspacio]);

    const handleCrearEvento = () => {
        if (!fechaInicio || !fechaFinal || !horaInicio || !horaFinal) {
            alert("Por favor, completa todos los campos antes de crear el evento.");
            return;
        }
        crearEventoEnCalendario();
    };
    // Función para manejar el cambio en el slider
    const handleSliderChange = (value) => {
        // Verifica si el valor actual está en los horarios ocupados
        if (!horariosOcupados.includes(value)) {
            setValorSeleccionado(value); // Actualiza el estado solo si está disponible
        }
    }

    const crearEventoEnCalendario = async () => {
        const url = "https://us-central1-laofi-f175b.cloudfunctions.net/createEventInCalendar";
        const data = {
            fechaInicio: fechaInicio,
            fechaFinal: fechaFinal,
            horaInicio: horaInicio,
            horaFinal: horaFinal,
            userName: userName,
            calendarId: calendarId
        };

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();
            //console.log("Respuesta del servidor:", result);
            //console.log(data);
            if (result.success) {
                //alert("Evento creado con éxito");
            } else {
                alert("Error al crear el evento: " + result.message);
            }
        } catch (error) {
            console.error("Error en la solicitud:", error);
            alert("Hubo un problema al conectar con el servidor Intenta mas Tarde");
        }
    };

    // Llamar a la función cuando sea necesario (por ejemplo, en un botón)
    const formatearFecha = (fecha) => {
        if (!(fecha instanceof Date)) {
            console.error("Fecha no es un objeto Date:", fecha);
            return "";
        }
        const dia = String(fecha.getDate()).padStart(2, "0");
        const mes = String(fecha.getMonth() + 1).padStart(2, "0"); // +1 porque enero es 0
        const año = fecha.getFullYear();
        return `${año}-${mes}-${dia}`;
    };
    const handleReservation = async () => {
        setSuccessModalIsOpen(false);
        const auth = getAuth();
        const currentUser = auth.currentUser;
        if (!currentUser) {
            openModal('Debes iniciar sesión para realizar una reserva.');
            return;
        }

        setUserId(currentUser.uid);

        try {
            // Obtener los datos del usuario (coins, cédula, RUC)
            const userRef = doc(db, 'usuarios', currentUser.uid);
            const docSnap = await getDoc(userRef);
            if (!docSnap.exists()) {
                return;
            }

            const userData = docSnap.data();

            // Validar cédula o RUC
            if (!userData.cedula && !userData.ruc) {
                setCedulaRucModalIsOpen(true);
                return;
            }

            // Validar si el usuario tiene suficientes coins
            if (userData.coins < cost) {
                openModal('No tienes suficientes coins para realizar la reserva.');
                return;
            }

            // Preparar los datos de la reserva
            const reservationData = {
                fechaInicio: formattedStartDate,
                fechaFinal: formattedEndDate,
                horaInicio: formatTime(timeRange[0]),
                horaFinal: formatTime(timeRange[1]),
                costoReserva: cost,
                idUser: currentUser.uid,
                IdEspacio: IdEspacio,
                reseñaRealizada: false,
                calUsers: false,
            };

            // Obtener datos del espacio desde la tabla 'espacios'
            const espacioDoc = await getDoc(doc(db, 'espacios', IdEspacio));
            if (!espacioDoc.exists()) {
                openModal("El espacio no existe.");
                return;
            }

            const espacioData = espacioDoc.data();
            const tipoEspacio = espacioData.TipoEspacio;
            const capacidadMax = espacioData.CapacidadMax;

            // Obtener el documento del contador de reservas
            const contadorDocRef = doc(db, 'contadorReservas', IdEspacio);
            const contadorDoc = await getDoc(contadorDocRef);
            let contadorReservas = contadorDoc.exists() ? contadorDoc.data().contador || 0 : 0;

            // Validación para tipoEspacio específico
            if (tipoEspacio === "tipoEspacio_pvozqd0m4") {
                if (contadorReservas >= capacidadMax) {
                    openModal('No hay cubículos disponibles para la fecha seleccionada.');
                    return;
                }

                // Actualizar el contador de reservas y agregar la reserva
                await setDoc(contadorDocRef, { contador: contadorReservas + 1 });
                await addDoc(collection(db, 'reservas'), reservationData);

                // Actualizar los coins del usuario en Firebase
                const newCoins = userData.coins - cost;
                await updateDoc(userRef, { coins: newCoins });

                openModal('Reserva realizada con éxito.', 'positive');
                return;
            }

            // Validaciones para otros tipos de espacio
            let conflictFound = false;
            let conflictDate = '';
            let conflictHour = '';

            const querySnapshot = await getDocs(
                query(collection(db, 'reservas'), where("IdEspacio", "==", IdEspacio))
            );

            const newStartTime = formatTime(timeRange[0]);
            const newEndTime = formatTime(timeRange[1]);
            const newStartDate = new Date(formattedStartDate.split('/').reverse().join('-'));
            const newEndDate = new Date(formattedEndDate.split('/').reverse().join('-'));
            let currentDate = new Date(newStartDate);

            while (currentDate <= newEndDate) {
                const formattedCurrentDate = currentDate.toISOString().split('T')[0];

                querySnapshot.forEach((doc) => {
                    const existingReservation = doc.data();
                    const existingStartDate = new Date(existingReservation.fechaInicio.split('/').reverse().join('-'));
                    const existingEndDate = new Date(existingReservation.fechaFinal.split('/').reverse().join('-'));
                    const existingStartTime = existingReservation.horaInicio;
                    const existingEndTime = existingReservation.horaFinal;

                    if (currentDate >= existingStartDate && currentDate <= existingEndDate) {
                        if (newStartTime < existingEndTime && newEndTime > existingStartTime) {
                            conflictFound = true;
                            conflictDate = formattedCurrentDate;
                            conflictHour = `${existingStartTime} - ${existingEndTime}`;
                        }
                    }
                });

                if (conflictFound) {
                    openModal(`El ${conflictDate} ya está reservado en las horas ${conflictHour}. Por favor, elige otro horario.`);
                    return;
                }

                currentDate.setDate(currentDate.getDate() + 1);
            }
            // Llamar a la función de Firebase para crear el evento en Google Calendar
            /* const functions = getFunctions();
            const createEvent = httpsCallable(functions, 'createEventInCalendar');
            await createEvent(reservationData); */
            // Realizar la reserva
            await addDoc(collection(db, 'reservas'), reservationData);

            // Actualizar los coins del usuario
            const newCoins = userData.coins - cost;
            await updateDoc(userRef, { coins: newCoins });

            openModal('Reserva realizada con éxito.', 'positive');
            handleCrearEvento();
        } catch (error) {
            console.error("Error realizando la reserva:", error.message);
            openModal("Ocurrió un error al realizar la reserva. Por favor, intenta de nuevo más tarde.");
        }
    };



    useEffect(() => {
        if (!IdEspacio) {
            return; // Detener la ejecución si IdEspacio es undefined o vacío
        }

        const obtenerReseñas = async () => {
            const db = getFirestore();
            const reseñasRef = collection(db, 'reseñas');
            const q = query(reseñasRef, where('idEspacio', '==', IdEspacio)); // Filtro por IdEspacio

            try {
                const querySnapshot = await getDocs(q);
                let calificacionesTotales = 0;
                let contadorCalificaciones = 0;
                const reseñasFiltradas = [];

                for (const docSnap of querySnapshot.docs) {
                    const data = docSnap.data();

                    if (data.calificacion >= 4.5) {
                        // Buscar el nombre y apellido del usuario
                        const usuarioRef = doc(db, 'usuarios', data.userId); // Crear referencia al documento del usuario
                        const usuarioDoc = await getDoc(usuarioRef);
                        const usuarioData = usuarioDoc.exists() ? usuarioDoc.data() : { nombre: "Desconocido", apellido: "" };

                        reseñasFiltradas.push({
                            Reseña: data.Reseña,
                            calificacion: data.calificacion,
                            usuario: `${usuarioData.name} ${usuarioData.lastName}`.trim(),
                        });
                    }

                    calificacionesTotales += data.calificacion;
                    contadorCalificaciones++;
                }

                // Calcular el promedio de calificación
                const promedio = contadorCalificaciones > 0 ? calificacionesTotales / contadorCalificaciones : 0;
                setPromedioCalificacion(promedio);
                setReseñas(reseñasFiltradas); // Guarda las reseñas filtradas en el estado
            } catch (error) {
            }
        };

        obtenerReseñas();
    }, [IdEspacio]);




    const handleNextReseña = () => {
        setCurrentReseñaIndex((prevIndex) => (prevIndex + 1) % reseñas.length);
    };

    const handlePrevReseña = () => {
        setCurrentReseñaIndex((prevIndex) => (prevIndex - 1 + reseñas.length) % reseñas.length);
    };

    if (loading) {
        return <LoadingScreen></LoadingScreen>
    }
    return (
        <div>
            <Navbar />
            <ToastContainer />
            <div className="rosania_content">
                <div className="rosania_left">
                    <h1 className='rosania_left_titulo'>{EspacioData.tipoespacio}</h1>
                    <h3 className='rosania_left_lugar'>{EspacioData.nombreLugar}</h3>
                    <h3 className='rosania_left_space'>
                        {EspacioData.nombre}
                        {iconUrl ? (
                            <img src={iconUrl} alt='logo' className="volcan_amarillo" />
                        ) : (
                            <span className="icon-placeholder"> {/* Este span puede ser un espacio vacío o un texto alternativo */}
                                {/* Aquí puedes dejarlo vacío o poner un texto como "logo no disponible" */}
                            </span>
                        )}
                    </h3>
                    <br></br>
                    <h1 className='rosania_left_esp'>
                        {EspacioData.descripcion}
                    </h1>

                    <div className="other_images_container" style={{ display: 'flex', alignItems: 'center', gap: '40px' }}>
                        <button className="arrow_left" onClick={handlePrev}>
                            <VscArrowCircleLeft style={{ width: '30px', height: '30px', fill: 'black' }} />
                        </button>

                        <div className="other_images" style={{ display: 'flex', gap: '31px' }}>
                            {getThumbnailImages().map((image, index) => (
                                // eslint-disable-next-line jsx-a11y/alt-text
                                <img
                                    key={index}
                                    src={image}
                                    className={`Rosania${index + 1}`}
                                    style={{ cursor: 'pointer', width: '100px', height: '100px', borderRadius: '20px' }}
                                />
                            ))}
                        </div>
                        <button className="arrow_right" onClick={handleNext} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                            <VscArrowCircleRight style={{ width: '30px', height: '30px', fill: 'black' }} />
                        </button>
                    </div>

                    <img src={DiseñoIzquierda} alt='DiseñoIzquierda' className='DiseñoIzquierda' />
                </div>

                <div className="rosania_right">
                    <img
                        src={images[currentIndex]}
                        alt="Imagen Grande"
                        className="Rosania4"
                        style={{ width: '400px', height: '400px', borderRadius: '20px' }}
                    />
                </div>
            </div>
            <div className="gridReservacionPlace" style={{ marginTop: '2em' }}>
                <div className='grid_reseñaseinfo'>
                    <div className="p-4 bg-white shadow-md rounded-lg border-2 border-gray-400">

                        <h2 className="textprincipaltab1" style={{ backgroundColor: EspacioData.color || '#ffffff00' }}>
                            <br></br>{EspacioData.descripcionespacio}
                        </h2>

                        <div className="flex">
                            {/* logo a la izquierda */}
                            <div className=" p-4">
                                {iconUrl ? (
                                    <img src={iconUrl} alt='logo' className="gridlogos" />
                                ) : (
                                    <span className="icon-placeholder"> {/* Este span puede ser un espacio vacío o un texto alternativo */}
                                        {/* Aquí puedes dejarlo vacío o poner un texto como "logo no disponible" */}
                                    </span>
                                )}

                            </div>

                            {/* Sección de Capacidad */}
                            <div className="flex flex-col justify-center items-center p-4">
                                <h3 className="text-xl font-bold mb-2">CAPACIDAD</h3>
                                <div className="flex flex-col items-center mb-2">
                                    <FaUsers style={{ color: EspacioData.color || '#ffffff00', width: '2em', height: '2em', marginBottom: '0.5em' }} />
                                    <span className='capaciadespacios' style={{ fontSize: '28px', textAlign: 'center' }}>{EspacioData.capacidadMin} - {EspacioData.capacidadMax}</span>
                                </div>
                                <p className='palabraPersonas' style={{ marginBlockStart: '0em', textAlign: 'center' }}>Personas</p>
                            </div>

                            {/* Sección de Accesorios */}
                            <div className="flex flex-col justify-center items-center p-4">
                                <h3 className="text-xl font-bold mb-2">ACCESORIOS</h3>
                                <div className="flex flex-col items-center">
                                    <FaProjectDiagram style={{ color: EspacioData.color || '#ffffff00', width: '2.5em', height: '2em', marginBottom: '0.2em', marginTop: '14px' }} className="text-orange-500" />
                                    <p className='accesorios_espacios' style={{ textAlign: 'center', fontSize: '21px' }}>{EspacioData.accesorios}</p>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div alt="reseñastemp" className="reseñastemp" style={{ backgroundColor: EspacioData.color || '#dfb4515c' }}>
                        <div className='puntajeytituloReseñas'>
                            <h1 className='titulo_reseña'>Reseñas</h1>
                            <div className='calificacion_icono' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '24px', marginTop: '-40px' }}>
                                <FaStar style={{ color: '#ffffff', width: '50%', marginRight: '17px' }} />
                                <h2> {promedioCalificacion.toFixed(2)}</h2>

                            </div>
                        </div>
                        <div className='content_comentarios' style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                            <button
                                className="arrow_left1"
                                onClick={handlePrevReseña}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: reseñas.length > 0 ? 'pointer' : 'not-allowed',
                                }}
                                disabled={reseñas.length === 0}
                            >
                                <VscArrowCircleLeft style={{ width: '30px', height: '30px', fill: 'black' }} />
                            </button>

                            {reseñas.length > 0 && reseñas[currentReseñaIndex] ? (
                                <div key={currentReseñaIndex} className="Reseña_por_usuario">
                                    <p className="textoReseña">{reseñas[currentReseñaIndex]?.usuario || 'Anónimo'}</p>
                                    <p className="textoReseña1">{reseñas[currentReseñaIndex]?.Reseña || 'Sin reseña disponible'}</p>
                                </div>
                            ) : (
                                <p>No hay reseñas disponibles</p>
                            )}


                            <button
                                className="arrow_right1"
                                onClick={handleNextReseña}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: reseñas.length > 0 ? 'pointer' : 'not-allowed',
                                }}
                                disabled={reseñas.length === 0}
                            >
                                <VscArrowCircleRight style={{ width: '30px', height: '30px', fill: 'black' }} />
                            </button>
                        </div>


                    </div>
                </div>

                <div className='grid_reserva'>
                    <h2 className="ReservaTitulo" style={{ marginBottom: '20px' }}>RESERVAR</h2>
                    <p className='nombrelugar' style={{ textAlign: 'left', fontSize: '18px', marginTop: '-14px', marginBottom: '27px', textDecoration: 'underline' }}>{EspacioData.nombre}</p>

                    <div className="ReservaFecha" style={{ backgroundColor: '#b7b5b5d4' }}>
                        <FaCalendar style={{ marginRight: '10px' }} />
                        <span>
                            {isSelectingStartDate
                                ? "Selecciona la fecha de inicio"
                                : "Selecciona la fecha final"}
                            <br />
                            {formattedStartDate} hasta {formattedEndDate}
                        </span>
                        <FaSearch style={{ marginLeft: '10px' }} />
                    </div>

                    <div className="calendar-container">
                        <div className="dual-calendar">
                            {/* Primer calendario (Mes actual) */}
                            <Calendar
                                onClickDay={handleDateChange}
                                minDate={new Date()}
                                className="react-calendar"
                                activeStartDate={activeStartDate1}
                                onActiveStartDateChange={({ activeStartDate }) => setActiveStartDate1(activeStartDate)}
                                tileClassName={({ date, view }) => {
                                    if (view === "month") {
                                        if (fechaInicio && date.toDateString() === fechaInicio.toDateString()) return "start-date";
                                        if (fechaFinal && date.toDateString() === fechaFinal.toDateString()) return "end-date";
                                        if (fechaInicio && fechaFinal && date > fechaInicio && date < fechaFinal) return "range-date";
                                    }
                                    return null;
                                }}
                            />

                            {/* Segundo calendario (Mes siguiente) */}
                            <Calendar
                                onClickDay={handleDateChange}
                                minDate={new Date()}
                                className="react-calendar"
                                activeStartDate={activeStartDate2}
                                onActiveStartDateChange={({ activeStartDate }) => setActiveStartDate2(activeStartDate)}
                                tileClassName={({ date, view }) => {
                                    if (view === "month") {
                                        if (fechaInicio && date.toDateString() === fechaInicio.toDateString()) return "start-date";
                                        if (fechaFinal && date.toDateString() === fechaFinal.toDateString()) return "end-date";
                                        if (fechaInicio && fechaFinal && date > fechaInicio && date < fechaFinal) return "range-date";
                                    }
                                    return null;
                                }}
                            />
                        </div>
                    </div>
                    <div className="horizontal-slider-comp">

                        <p className='selecthoras' style={{ textAlign: 'center', fontSize: '18px', marginBottom: '10px' }}> Seleccione el horario de reserva: {formatTime(timeRange[0])} - {formatTime(timeRange[1])}</p>
                        <ReactSlider
                            className="horizontal-slider"
                            thumbClassName="thumb"
                            trackClassName="track"
                            value={timeRange}
                            onChange={handleTimeChange} // ✅ Asigna las horas al cambiarmin={0}
                            max={48} // 0-48 para cubrir 24 horas (cada 30 minutos)
                            step={1}
                            renderThumb={(props) => {
                                const { key, ...restProps } = props; // Extraer 'key' de props
                                return (
                                    <div
                                        key={key} // Pasar 'key' directamente
                                        {...restProps} // Pasar el resto de props
                                        style={{ ...restProps.style, background: EspacioData.color }} // Aplicar el color de fondo al thumb
                                    />
                                );
                            }}
                            renderTrack={(props, state) => {
                                const isOccupied = horariosOcupados.includes(Number(state.index));
                                //console.log(`Track index: ${state.index}, Ocupado: ${isOccupied}`);

                                return (
                                    <div
                                        {...props}
                                        style={{
                                            ...props.style,
                                            backgroundColor: isOccupied ? "#ff4d4d" : "gray", // Rojo para ocupado, verde para disponible
                                        }}
                                    />
                                );
                            }}

                        />
                        <div>
                            <p style={{ textAlign: 'center', fontSize: '18px', marginTop: '3pc' }}>Costo Total: {cost} coins</p>
                        </div>
                    </div>
                    <button className='confirmarReservacion' onClick={handleReservation} >Reservar Ahora</button>

                </div>

            </div>
            {/* Modal para mostrar mensajes */}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className={'MensajeReserva'}
            >
                <h2 className={modalTitle === '¡Genial!' ? 'positive-message' : 'negative-message'}>
                    {modalTitle}
                </h2>
                <p>{modalMessage}</p>
                <button
                    onClick={() => {
                        if (modalMessage === 'Debes iniciar sesión para realizar una reserva.') {
                            localStorage.setItem('reservation', 'true');
                            const urlActual = window.location.href;
                            localStorage.setItem("reservationUrl", urlActual);
                            navigate('/login');
                        } else if(modalMessage==='Reserva realizada con éxito.'){
                            navigate('/reservasRealizadas');
                        }
                        else {
                            closeModal(); // Cierra el modal si el mensaje no es de sesión
                        }
                    }}
                >
                    Cerrar
                </button>
            </Modal>
            <Modal isOpen={cedulaRucModalIsOpen}
                onRequestClose={() => setCedulaRucModalIsOpen(false)} className="MensajeReserva">
                <h2 className={modalTitle === '¡Genial!' ? 'positive-message' : 'negative-message'} > Lo sentimos</h2>
                <h2>Debe ingresar su cédula o RUC para continuar con la reserva</h2>
                <input
                    type="text"
                    value={cedulaRuc}
                    onChange={handleChange}
                    placeholder="Ingrese cédula o RUC"
                    maxLength={13} // Limitar la longitud a 13 caracteres (para RUC)
                />
                <button onClick={handleSubmit}>Guardar</button>
            </Modal>
            {/* Mostrar el modal de error si la cédula o RUC no es válida */}
            <Modal isOpen={errorModalIsOpen} onRequestClose={() => setErrorModalIsOpen(false)} className="ErrorModal">
                <h2 style={{ color: 'red' }}>Error</h2>
                <p>{errorMessage}</p>
                <button onClick={() => setErrorModalIsOpen(false)}>Cerrar</button>
            </Modal>
            {/* Mostrar el modal de éxito cuando la cédula o RUC se guarden correctamente */}
            <Modal isOpen={successModalIsOpen} onRequestClose={() => setSuccessModalIsOpen(false)} className="SuccessModal">
                <h2 style={{ color: 'green' }}>¡Éxito!</h2>
                <p>Cédula o RUC guardado correctamente.</p>
                <button onClick={(handleReservation)}>Cerrar</button>
            </Modal>
        </div>
    );
};

export default Officerosania;